import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as React from 'react';

const ELQuestionnaire: React.FC<SvgIconProps> = props => {
	return (
		<SvgIcon {...props}>
			<path
				transform="scale(.26458)"
				d="m20.738 20.109c-4.2803 0-7.7266 3.4463-7.7266 7.7266v51.547c0 4.2803 3.4463 7.7266 7.7266 7.7266h51.547c4.2803 0 7.7246-3.4463 7.7246-7.7266v-28.861l-9.2812 8.7461v16.314c0 1.2443-1.0018 2.2461-2.2461 2.2461h-43.945c-1.2443 0-2.2461-1.0018-2.2461-2.2461v-43.945c0-1.2443 1.0018-2.2461 2.2461-2.2461h40.967l9.3633-8.834c-0.80782-0.2852-1.6741-0.44727-2.582-0.44727h-51.547z"
				fillRule="evenodd"
			/>
			<path
				d="m7.0423 12.807 5.9152 6.2692 11.426-10.781-2.5041-2.6539-8.8477 8.3481-3.4111-3.6153z"
				fillRule="evenodd"
			/>
		</SvgIcon>
	);
};

export default ELQuestionnaire;



// WEBPACK FOOTER //
// ./src/icons/ELQuestionnaire.tsx